type CurrencyProps = {
  value: number;
};

export function Currency({ value }: CurrencyProps) {
  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);

  return (
    <>{formattedValue}</>
  );
}
